import { Control, useController } from "react-hook-form";
import React from "react";
import BaseDropdown from "@reusables/dropdowns/BaseDropdown";
import { useTranslation } from "react-i18next";
import { FieldError } from "react-hook-form/dist/types";
import BaseDatepicker from "@reusables/BaseDatepicker";
import { DatepickerDayjs } from "@reusables/BaseDatepicker/types";
import { BatchNumbersScheme } from "./types";

type BatchItemFieldsProps = {
    control: Control<BatchNumbersScheme>;
    batchNumber: `lines.${number}.batch_numbers.${number}`;
    availableBatchNumbers?: {
        batch_number: string;
        expiration_date?: DatepickerDayjs;
    }[];
    disabled?: boolean;
}


export default function BatchItemFields({ batchNumber, control, disabled, ...props }: BatchItemFieldsProps) {
    const { t } = useTranslation("", { keyPrefix: "sales.picking.modals.batchNumbers" });

    const { field: item, fieldState: itemState } = useController({
        name: batchNumber,
        control
    });

    const batchNumberValue = item.value ? {
        batch_number: item.value.batch_number,
        expiration_date: item.value.expiration_date
    } : null;

    const batchNumberError = (itemState.error as { batch_number?: FieldError })?.batch_number;
    const expirationDateError = (itemState.error as { expiration_date?: FieldError })?.expiration_date;

    return (
        <>
            {/* Value */}
            <BaseDropdown
                value={batchNumberValue}
                error={batchNumberError}

                options={props.availableBatchNumbers}

                getter={{
                    key: (opt) => opt.batch_number + opt.expiration_date?.format("DD.MM.YYYY"),
                    label: (opt) => opt.batch_number,
                    caption: (opt) => opt.expiration_date?.format("DD.MM.YYYY") ?? ""
                }}

                onChange={(value) => {
                    if (value) {
                        const newState = {
                            ...item.value,
                            batch_number: value?.batch_number,
                            expiration_date: value?.expiration_date
                        };

                        item.onChange(newState);
                    }
                }}

                onInputChange={(_, value) => {
                    item.onChange({ ...item.value, batch_number: value });
                }}

                placeholder={t("field.placeholder")}
                sx={{
                    "&, & input": {
                        background: "#F9F9F9",
                        padding: "8px",
                        width: "100%"
                    }
                }}

                hideArrow
                hideNothingFound

                freeSolo
                autocomplete

                disabled={disabled}

                disableClearable
            />

            {/* Expiration date*/}
            <BaseDatepicker
                value={item.value?.expiration_date}
                error={expirationDateError}

                onChange={(value) => {
                    item.onChange({ ...item.value, expiration_date: value });
                }}

                placeholder={t("fields.expirationDate.placeholder")}

                inputSx={{
                    "&": {
                        padding: 0,
                        "input": {
                            background: "#F9F9F9",
                            padding: "12px",
                        }
                    }
                }}

                disabled={disabled}
            />
        </>
    );
}